import React from 'react'
import { Element, baseChildNodes, baseNormalizer } from './ElementPlugin'
import { answerInput } from 'styles/inputs'
import styled from 'react-emotion'

const childTypes = ['elementTitle', 'openAnswer']

const OpenPlugin = () => {
  return {
    schema: {
      blocks: {
        open: {
          parent: { object: 'document' },
          nodes: baseChildNodes.concat([
            {
              match: {
                type: 'openAnswer'
              },
              min: 0
            }
          ]),
          normalize: (editor, { code, node, child, index }) => {
            baseNormalizer(editor, { code, node, child, index })
            switch (code) {
              case 'child_type_invalid':
                return editor.setNodeByKey(child.key, 'elementTitle')
              case 'child_max_invalid':
                if (index > 1) {
                  return editor.setNodeByKey(child.key, 'openAnswer')
                }
                break
              case 'child_unknown':
                return editor.undo()
              default:
                break
            }
          }
        }
      }
    },
    onConstruct(editor, next) {
      editor.registerElement('open', {
        menu: {
          command: 'convertToOpen',
          label: 'Text',
          icon: 'ion-document-text',
          type: 'Open'
        },
        childTypes: childTypes
      })
      return next()
    },
    commands: {
      convertToOpen(editor, node, data = {}) {
        editor.convertToElement(node, 'open', childTypes, data)
      }
    },
    renderNode(props, editor, next) {
      switch (props.node.type) {
        case 'open':
          return <Open {...props} />
        case 'openAnswer':
          return <OpenAnswer {...props} />
        default:
          return next()
      }
    }
  }
}

const TextInput = styled.div`
  width: 318px;
  opacity: 0.6;
  ${answerInput};
`

const Open = props => (
  <Element className={'element-open'} iconName={'ion-document-text'} {...props}>
    {props.children}
  </Element>
)

const OpenAnswer = props => (
  <Element.AnswerRow>
    {props.children}
    <TextInput className={'textarea'} contentEditable={false} />
  </Element.AnswerRow>
)

export default OpenPlugin



// WEBPACK FOOTER //
// ./src/components/Editor/plugins/OpenPlugin.js